import { render, staticRenderFns } from "./vfg-field-custom-textlist.vue?vue&type=template&id=54451b0a"
import script from "./vfg-field-custom-textlist.vue?vue&type=script&lang=js"
export * from "./vfg-field-custom-textlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports